<template>
  <v-layout row wrap :class="['videos-list']" align-space-between fill-height v-if="getAlbumInfo() && getAlbumInfo().slug">
    <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
      <h3 :class="['font-weight-light', 'subheading', 'pb-3']">
        {{ $lang.videosFromTheAlbum }}&nbsp;"<router-link :class="['white--text']" :to="makeAlbumUri(getAlbumInfo().slug)" v-html="getAlbumInfo().album.replace('Theophag-st', $config.appName)" :title="getAlbumInfo().album.replace('Theophag-st', $config.appName)" />"
      </h3>
      <v-divider />
    </v-flex>
    <v-flex lg6 md6 sm6 xs12 v-for="(video, index) in videos" :key="index" :class="['pa-2']">
      <v-card :class="['full-height', 'elevation-8']">
        <v-card-text :class="['pa-1']">
          <video-wrapper :play-videos-on-facebook="$config.playVideosOnFacebook" :video="video" />
<!--          <div :class="['video-wrapper']" :title="playVideosOnFacebook ? $lang.watchOnFacebook(video.title) : null" :style="playVideosOnFacebook ? videoUrlToThumb(makeSingleVideoUrl(video.id)) : null" @click="toFacebookVideo(video.id)">-->
<!--            <iframe v-if="!playVideosOnFacebook" seamless scrolling="no" frameborder="0" allowfullscreen="true" name="facebook-embedded-player" allow="autoplay;clipboard-write;encrypted-media;picture-in-picture;web-share" :src="makeFacebookListPlayerUrl(video.id)" />-->
<!--          </div>-->
        </v-card-text>
        <v-card-actions :class="['px-1', 'pt-0', 'pb-1']">
          <span v-html="video.title" :class="['mx-1']" />
          <v-spacer />
          <v-btn :class="['ma-0']" @click.capture="gtagEvent('play', 'video', 'single-video-page', video.title)" :to="makeSingleVideoUrl(video.id)" flat icon :title="$lang.play(video.title)" aria-label="play-video">
            <v-icon>mdi-play-circle-outline</v-icon>
          </v-btn>
          <v-btn :class="['ma-0']" @click.capture="gtagEvent('play', 'track', 'single-video-page', video.title)" :to="makeAlbumUri(getAlbumInfo().slug)" flat icon :title="$lang.viewRelease(getAlbumInfo().album)" aria-label="play-video">
            <v-icon>mdi-music-note</v-icon>
          </v-btn>
          <v-btn :class="['ma-0']" @click.capture="gtagEvent('play', 'video', 'video-on-facebook', video.title)" target="_blank" :href="`https://www.facebook.com/watch/?v=${video.id}`" aria-label="watch-on-facebook" flat icon :title="$lang.watchOnFacebook(video.title)">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'VideoCategory',
  mixins: [
    methods
  ],
  props: {
    videos: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    }
  },
  methods: {
    getAlbumInfo () {
      return this.videos[0]
    }
  }
}
</script>
<style>
.videos-list iframe
{
  display: block;
  border: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/video-category.vue